import { CSSButton } from "components/Button/Button";
import { createGlobalStyle, keyframes } from "styled-components";
import Keyframes from "./keyframes";
import variables from "./variables";

const GlobalStyle = createGlobalStyle`
  html {
    height: 100%;
  }
  
  body {
    margin: 0;
    font-family: Jura, -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Cantarell", "Fira Sans",
      "Droid Sans", "Helvetica Neue", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: white;
    background-color: #313e4f;
    background-size: cover;
    background-repeat: no-repeat;
    background-image: linear-gradient(-45deg, #1a293b, #0f1925);
    background-attachment:fixed;
    height: 100%;
  }

  #root {
    height: 100%;
  }

  * {
    box-sizing: border-box;
  }

  img {
    width: 100%;
  }

  input {
    font-family: Jura
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
      /* display: none; <- Crashes Chrome on hover */
      -webkit-appearance: none;
      margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
  }

  input[type="number"] {
    padding: 8px;
    width: 60px;
     -moz-appearance:textfield; /* Firefox */
  }

  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New", monospace;
  }

  ::-webkit-scrollbar {
    width: 12px;
  }
  
  ::-webkit-scrollbar-track {
    background: #0c121a;
  }
  
  ::-webkit-scrollbar-thumb {
    background: #ffffff;
    border-radius: 10px;
  }

  textarea, input {
    background: #06090e;
    border: none;
    border-radius: 5px;
    color: white;
    outline: none;
    padding: 16px;
  }

  button.firebaseui-idp-button {
    ${CSSButton}

    font-weight: 600;
    padding: 8px 32px;
  }

  .mdl-card {    
    background: transparent !important;
    box-shadow: none !important;

    input, label {
      color: white !important;
      border-color: white !important;
    }

  }

  .firebaseui-title {
    color: white !important;
  }
`;

export default GlobalStyle;
